import useMedia from './useMedia';

export function useIsMobileSm() {
  return useMedia('(max-width: 767px)');
}
